enum CommunicationTypes {
  Email = "Email",
  Message = "Message",
  Teams = "Teams",
  GenericMessages = "GenericMessages",
}
export default CommunicationTypes;
